import api from "./Api";

class MultiempresaService {
  GetGrupos() {
    return api.get("/v1/Multiempresa/Grupos").then((response) => {
      return response.data;
    });
  }

  SaveGrupo(payload) {
    return api.post("/v1/Multiempresa/Grupo", payload).then((response) => {
      return response.data;
    });
  }

  DeleteGrupo(id) {
    return api.delete(`/v1/Multiempresa/Grupo/${id}`).then((response) => {
      return response.data;
    });
  }

  GetLogs(idGrupo = null) {
    const suffix = idGrupo ? `?idGrupo=${idGrupo}` : "";
    return api.get(`/v1/Multiempresa/Logs${suffix}`).then((response) => {
      return response.data;
    });
  }

  Reprocessar(id) {
    return api.post(`/v1/Multiempresa/Reprocessar/${id}`).then((response) => {
      return response.data;
    });
  }

  GetEmpresasPermitidas() {
    return api.get("/v1/Multiempresa/EmpresasPermitidas").then((response) => {
      return response.data;
    });
  }

  GetUsuariosGrupo(idGrupo) {
    return api
      .get(`/v1/Multiempresa/Grupo/${idGrupo}/Usuarios`)
      .then((response) => {
        return response.data;
      });
  }

  GetReceberConsolidado(payload) {
    return api
      .post("/v1/Multiempresa/Receber/Consultar", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetPagarConsolidado(payload) {
    return api
      .post("/v1/Multiempresa/Pagar/Consultar", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetPedidosConsolidado(payload) {
    return api
      .post("/v1/Multiempresa/Pedido/Consultar", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetEstoqueConsolidado(payload) {
    return api
      .post("/v1/Multiempresa/Estoque/Consultar", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetResumo(payload) {
    return api
      .post("/v1/Multiempresa/Relatorios/Resumo", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetDashboard(payload) {
    return api
      .post("/v1/Multiempresa/Relatorios/Dashboard", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetDre(payload) {
    return api
      .post("/v1/Multiempresa/Relatorios/Dre", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetVendas(payload) {
    return api
      .post("/v1/Multiempresa/Relatorios/Vendas", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetProdutosServicos(payload) {
    return api
      .post("/v1/Multiempresa/Relatorios/ProdutosServicos", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetFluxoCaixa(payload) {
    return api
      .post("/v1/Multiempresa/Relatorios/FluxoCaixa", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetInadimplencia(payload) {
    return api
      .post("/v1/Multiempresa/Relatorios/Inadimplencia", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetCurvaABC(payload) {
    return api
      .post("/v1/Multiempresa/Relatorios/CurvaABC", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new MultiempresaService();
